var map = {
	"./EVO.png": 1674,
	"./Path 20295.png": 1675,
	"./ab-img.webp": 1676,
	"./ab-title-cn.webp": 1677,
	"./ab-title-en.webp": 1678,
	"./ag-img.png": 1679,
	"./ag-img.webp": 1680,
	"./ag-title-cn.webp": 1681,
	"./ag-title-en.webp": 1682,
	"./chess-img.webp": 1683,
	"./coin-img.webp": 1684,
	"./content-img.webp": 1685,
	"./dg-img.webp": 1686,
	"./dg-title-cn.webp": 1687,
	"./dg-title-en.webp": 1688,
	"./diamond-img.webp": 1689,
	"./dice-coin.webp": 1690,
	"./ea-img.webp": 1691,
	"./ea-title-cn.webp": 1692,
	"./ea-title-en.webp": 1693,
	"./evo-img.webp": 1694,
	"./evo-title-cn.webp": 1695,
	"./evo-title-en.webp": 1696,
	"./golddice-img.webp": 1697,
	"./gp-img.webp": 1698,
	"./gp-title-cn.webp": 1699,
	"./gp-title-en.webp": 1700,
	"./heart-coin-img.webp": 1701,
	"./lc-bg.webp": 1702,
	"./mg-img.webp": 1703,
	"./mg-title-cn.webp": 1704,
	"./mg-title-en.webp": 1705,
	"./pp-img.webp": 1706,
	"./pp-title-cn.webp": 1707,
	"./pp-title-en.webp": 1708,
	"./pt-img.webp": 1709,
	"./pt-title-cn.webp": 1710,
	"./pt-title-en.webp": 1711,
	"./sa-img.webp": 1712,
	"./sa-title-cn.webp": 1713,
	"./sa-title-en.webp": 1714,
	"./sbo-img.webp": 1715,
	"./sbo-title-cn.webp": 1716,
	"./sbo-title-en.webp": 1717,
	"./spade-img.webp": 1718,
	"./title-cn.webp": 1719,
	"./title-en.webp": 1720,
	"./white-spade-img.webp": 1721
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1673;